export default __webpack_public_path__ + "static/media/case2 (2).11273f79.jpg";